
























































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import HolidaysBookingDetails from "../holidays/HolidaysBookingDetails.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";
import { HolidayProgramWithBookingsJson } from "../../shared/HolidayProgramJson";
import { HolidayProgramWithBookingJson } from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson from "../../shared/HolidayProgramBookingJson";

import CustomerJson from "../../shared/CustomerJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "HolidaysAll",
  components: {
    Loading,
    TableView,
    HolidaysBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    HolidayProgramBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      searchString: "",
      allHolidayPrograms: null as HolidayProgramJson[] | null,
      selectedHolidayProgramBookings: null as HolidayProgramWithBookingsJson | null,
      selectedHolidayProgramId: null as number | null,
      selectedHolidayBookingId: null as number | null,
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: HolidayProgramWithBookingJson | null, mode: string) {
      if (this.selectedHolidayProgramId != null) {
        if (item != null) {
          this.selectedHolidayBookingId = item.ID;
        } else {
          this.selectedHolidayBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllHolidayPrograms();
    },

    async loadAllHolidayPrograms() {
      this.allHolidayPrograms = null;
      this.selectedHolidayProgramId = null;
      this.selectedHolidayBookingId = null;
      this.selectedHolidayProgramBookings = null;

      if (this.restClient != null) {
        try {
          this.allHolidayPrograms = await this.restClient.getHolidayPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedHolidayProgramBookings() {
      if (this.allHolidayPrograms != null) {
        this.selectedHolidayProgramBookings = null;

        if (this.restClient != null && this.selectedHolidayProgramId != null) {
          try {
            this.selectedHolidayProgramBookings = await this.restClient.getHolidayProgramWithBookings(
              this.selectedHolidayProgramId
            );
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async reloadData() {
      this.loadSelectedHolidayProgramBookings();
    },

    //export subsudy list
    async downloadSubsidyList() {
      if (this.selectedHolidayProgramId != null) {
        this.isExporting = true;

        try {
          var data = await this.restClient.downloadHolidayProgramSubsidyListFile(this.selectedHolidayProgramId);
          if (data != null) {
            let atag = document.createElement("a");
            atag.style.display = "none";
            document.body.appendChild(atag);

            let blob = new Blob([data], { type: "octet/stream" });
            let url = window.URL.createObjectURL(blob);

            atag.href = url;
            //todo: besserer Dateiname
            atag.download = "ferienbetreuung.zip";
            atag.click();
            window.URL.revokeObjectURL(url);

            this.isExporting = false;
          }
        } catch (e) {
          this.isExporting = false;
          alert(e.message);
        }
      }
    },

    getAllChildNames(customers: CustomerJson[]) {
      var childs = "";

      for (let i = 0; i < customers.length; i++) {
        if (i != 0) {
          childs += ", ";
        }
        childs += customers[i].childFirstName;
        childs += " ";
        childs += customers[i].childLastName;
      }

      return childs;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    holidayColumns: function (): TableViewColumnDefinitions<HolidayProgramBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Erziehungsberechtigte:r",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Anzahl Kinder",
          td: (i) => i.customers.length + "",
        },
        {
          th: "Kinder",
          td: (i) => (i.customers.length > 0 ? vue.getAllChildNames(i.customers) : "--"),
        },
        {
          th: "Status",
          td: (i) => vue.HolidayProgramBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<HolidayProgramBookingJson>[];
    },

    filteredAllHolidayBookings(): HolidayProgramBookingJson[] | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var bookings: HolidayProgramBookingJson[] = this.selectedHolidayProgramBookings
          .bookings as HolidayProgramBookingJson[];

        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          bookings = bookings.filter((i) => {
            if (
              (i.customers.length > 0 && i.customers[0].guardianFirstName.toLowerCase().includes(token)) ||
              i.customers[0].guardianLastName.toLowerCase().includes(token) ||
              this.getAllChildNames(i.customers).toLowerCase().includes(token)
            ) {
              return true;
            }

            if (i.invoiceInfos && i.invoiceInfos.find((j) => j.invoiceNumber.toLowerCase().includes(token))) {
              return true;
            }

            return false;
          });
        }

        return bookings;
      }
    },
  },
});
